<template>
  <v-container
    fluid
    class="header-container"
    :class="{ 'header-white': $route.name != 'Home' }"
  >
    <v-container>
      <v-row>
        <v-col cols="4" lg="3" class="d-lg-none d-flex align-center">
          <v-app-bar color="transparent" class="elevation-0 menu-mobile">
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
          </v-app-bar>

          <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
            app
            class="menu-navigation"
          >
            <v-row class="ma-0 pa-5">
              <v-col>
                <v-img class="logo-header" max-width="70" to="/"></v-img>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-btn icon @click.stop="drawer = !drawer" class="py-8">
                  <span class="font-weight-bold" style="font-size: 20px">
                    x</span
                  >
                </v-btn>
              </v-col>
            </v-row>

            <v-list>
              <v-list-group :value="false">
                <template v-slot:activator>
                  <v-list-item
                    exact-path
                    class="text-capitalizes font-weight-bold"
                  >
                    <v-list-item-title>{{
                      $t("header.aboutUs")
                    }}</v-list-item-title>
                  </v-list-item>
                </template>

                <v-list class="px-8 py-0">
                  <v-list-item
                    v-for="(item, index) in aboutUs"
                    :key="index"
                    class="text-white font-weight-bold pa-lg-1"
                    :to="item.path"
                  >
                    <v-list-item-title v-html="item.name"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-group>
              <v-list-group :value="false">
                <template v-slot:activator>
                  <v-list-item
                    exact-path
                    class="text-capitalizes font-weight-bold"
                  >
                    <v-list-item-title>{{
                      $t("header.areas")
                    }}</v-list-item-title>
                  </v-list-item>
                </template>

                <v-list-group class="px-3" :value="true" sub-group>
                  <template v-slot:activator>
                    <v-list-item
                      exact-path
                      class="text-capitalizes font-weight-bold pl-0 ml-n2"
                    >
                      <v-list-item-title>{{
                        $t("header.medicalEquipment")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-for="(item, index) in areas.medicalEquipment"
                    :key="index"
                    class="text-white font-weight-bold pa-lg-1 pl-16"
                    :to="item.path"
                  >
                    <v-list-item-title
                      v-html="item.name"
                      class="pl-6"
                    ></v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <v-list-group class="px-3" :value="true" no-action sub-group>
                  <template v-slot:activator>
                    <v-list-item
                      exact-path
                      class="text-capitalizes font-weight-bold pl-0 ml-n2"
                    >
                      <v-list-item-title>{{
                        $t("header.patients")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-for="(item, index) in areas.patients"
                    :key="index"
                    class="text-white font-weight-bold pa-lg-1 pl-16"
                    :to="item.path"
                  >
                    <v-list-item-title
                      v-html="item.name"
                      class="pl-6"
                    ></v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <v-list-group class="px-3" :value="true" no-action sub-group>
                  <template v-slot:activator>
                    <v-list-item
                      exact-path
                      class="text-capitalizes font-weight-bold pl-0 ml-n2"
                    >
                      <v-list-item-title>{{
                        $t("header.press")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>

                  <v-list-item class="text-white font-weight-bold pa-lg-1">
                    <v-list-item-title>Dossier</v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </v-list-group>
              <v-list-item-group
                v-model="group"
                active-class="background-green"
              >
                <v-list-item
                  v-for="(item, index) in menuItems"
                  :key="index"
                  exact-path
                  class="text-capitalizes font-weight-bold px-8"
                  :to="item.path"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-col>
        <v-col cols="4" lg="3" class="pb-lg-0 d-flex justify-center justify-lg-start">
          <router-link to="/">
            <v-img class="logo-header"></v-img>
          </router-link>
        </v-col>
        <v-col cols="12" lg="7" class="d-none d-lg-flex align-center">
          <v-tabs class="justify-lg-end d-lg-flex menu-tabs" hide-slider>
            <v-tab class="pa-lg-0">
              <div class="text-center">
                <v-menu
                  offset-y
                  content-class="menu-about-us pt-lg-5 elevation-0 rounded-0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      dark
                      v-bind="attrs"
                      v-on="on"
                      :class="{
                        'active-tab': $route.matched[0].name === 'aboutUs',
                      }"
                      class="
                        text-capitalize text-white
                        font-weight-bold
                        elevation-0
                      "
                    >
                      {{ $t("header.aboutUs") }}
                    </v-btn>
                  </template>
                  <v-list class="transparent py-5 px-3">
                    <v-list-item
                      v-for="(item, index) in aboutUs"
                      :key="index"
                      class="text-white font-weight-bold pa-lg-1"
                      :to="item.path"
                    >
                      <v-list-item-title v-html="item.name"></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-tab>
            <v-tab class="pa-lg-0">
              <div class="text-center">
                <v-menu
                  offset-y
                  content-class="menu-area px-lg-5 pt-lg-14 elevation-0 rounded-0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      dark
                      v-bind="attrs"
                      v-on="on"
                      :class="{
                        'active-tab': $route.matched[0].name === 'areas',
                      }"
                      class="
                        text-capitalize text-white
                        font-weight-bold
                        elevation-0
                      "
                    >
                      {{$t("header.areas"),}}
                    </v-btn>
                  </template>
                  <v-row class="pb-lg-3">
                    <v-col cols="12" lg="4">
                      <h6
                        class="text-lg-body-1 text-gray font-weight-bold"
                        v-html="$t('header.medicalEquipment')"
                      ></h6>
                      <v-list class="transparent">
                        <v-list-item
                          v-for="(item, index) in areas.medicalEquipment"
                          :key="index"
                          class="text-white font-weight-bold pl-lg-0"
                          :to="item.path"
                        >
                          <v-list-item-title v-html="item.name">
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="12" lg="5" class="border-green">
                      <h6
                        class="text-lg-body-1 text-gray font-weight-bold"
                        v-html="$t('header.patients')"
                      ></h6>
                      <v-list class="transparent">
                        <v-list-item
                          v-for="(item, index) in areas.patients"
                          :key="index"
                          class="text-white font-weight-bold pl-lg-0"
                          :to="item.path"
                        >
                          <v-list-item-title
                            v-html="item.name"
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="12" lg="3">
                      <h6
                        class="text-lg-body-1 text-gray font-weight-bold"
                        v-html="$t('header.press')"
                      ></h6>
                      <v-list class="transparent">
                        <v-list-item
                          class="text-white font-weight-bold pl-lg-0"
                          download
                        >
                          <v-list-item-title>Dossier</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-menu>
              </div>
            </v-tab>
            <v-tab
              v-for="(item, index) in menuItems"
              :key="index"
              exact-path
              class="text-capitalize text-white font-weight-bold"
              :to="item.path"
              >{{ item.name }}</v-tab
            >
          </v-tabs>
        </v-col>
        <v-col cols="4" lg="2" class="d-flex align-center justify-end">
          <v-select
            :items="languages"
            v-model="lang"
            @change="changeLang()"
            :menu-props="{ 'content-class': 'menu-language' }"
            class="
              elevation-0
              pa-lg-0
              select-lang
              text-uppercase
              font-weight-bold
              mt-lg-2
            "
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
export default {
  name: "headerBar",
  data() {
    return {
      menuItems: [
        {
          name: this.$t("header.news"),
          path: { path: "/news" },
        },
        {
          name: this.$t("header.contactUs"),
          path: { path: "/contact-us" },
        },
      ],
      aboutUs: [
        {
          name: this.$t("header.aboutIncocegla"),
          path: { name: "aboutIncocegla" },
        },
        {
          name: this.$t("header.ourFacilities"),
          path: { name: "ourFacilities" },
        },
        {
          name: this.$t("header.glaucomaClub"),
          path: { name: "glaucomaClub" },
        },
        {
          name: this.$t("header.incoceglaFoundation"),
          path: { name: "incoceglaFoundation" },
        },
      ],
      areas: {
        medicalEquipment: [
          {
            name: this.$t("header.doctorsAndDepartments"),
            path: { name: "doctorsAndDepartments" },
          },
          {
            name: this.$t("header.otherAreas"),
            path: { name: "otherAreas" },
          },
        ],
        patients: [
          {
            name: this.$t("header.medicalInsurance"),
            path: { name: "medicalInsurance" },
          },
          {
            name: this.$t("header.pathologiesMoreConsulted"),
            path: { name: "pathologiesMoreConsulted" },
          },
          // {
          //   name: this.$t("header.faq"),
          //   path: { name: "faq" },
          // },
          // {
          //   name: this.$t("header.visionTest"),
          //   path: { path: "" },
          // },
        ],
      },
      lang: this.$i18n.locale,
      languages: ["es", "en"],
      drawer: false,
      group: null,
    };
  },
  methods: {
    changeLang() {
      localStorage.setItem("lang", this.lang);
      this.$router.go();
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>
